import { MergeFormConfig, FieldConfig } from "@/types/merge";
import { Match } from "@/components/MatchCard";

export const matchMergeConfig: MergeFormConfig<Match> = {
	entityName: "matches",
	excludeFields: ["id", "candidate_id", "job_id", "created_at", "updated_at"],
	fields: [
		{
			name: "score",
			type: "number",
			label: "Match Score",
			mergeBehavior: "manual",
			required: true,
			description: "Compatibility score between candidate and job"
		},
		{
			name: "description",
			type: "text",
			label: "Description",
			mergeBehavior: "ai",
			aiMergeEnabled: true,
			description: "Match analysis description"
		},
		{
			name: "strengths",
			type: "array",
			label: "Strengths",
			mergeBehavior: "combine",
			description: "Key strengths of the match"
		},
		{
			name: "weaknesses",
			type: "array",
			label: "Weaknesses",
			mergeBehavior: "combine",
			description: "Areas for improvement in the match"
		},
		{
			name: "status",
			type: "select",
			label: "Status",
			mergeBehavior: "latest",
			possibleValues: ["matched", "screening", "sent", "interview", "offer", "hired", "refused"],
			description: "Current status of the match"
		},
		{
			name: "ai_analysis",
			type: "presence",
			label: "AI Analysis",
			mergeBehavior: "combine",
			description: "Choose which AI analysis data structure to keep (complex JSON data)"
		}
	],
	customMergeLogic: async (merged: Partial<Match>, sources: Match[]): Promise<Partial<Match>> => {
		return merged;
	}
};
